import { render, staticRenderFns } from "./userinf.vue?vue&type=template&id=ef748c66&scoped=true"
import script from "./userinf.vue?vue&type=script&lang=js"
export * from "./userinf.vue?vue&type=script&lang=js"
import style0 from "./userinf.vue?vue&type=style&index=0&id=ef748c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef748c66",
  null
  
)

export default component.exports